
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats || (stats && stats.length == 0)"></loading>

			<i class="fa fa-download" aria-hidden="true" (click)="download()"></i>

			<hr>

			<table class="table">
				<thead>
					<th>{{ 'adminstat.common.Date' | translate }}</th>
					<th>{{ 'adminstat.common.Site' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.action' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.Category' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.Subject' | translate }}</th>
				</thead>

				<tbody>
					<tr *ngFor="let stat of stats" [style]="stat.mark == 'accessor | defer site' ? 'background-color:rgba(243, 123, 96, 0.6); color:white;' : ''">
						<td>
							{{ stat.time }}
						</td>
						
						<td>
							{{ stat.url }}
						</td>
						
						<td>
							{{ 'adminstat.support.accessor.' + stat.mark | translate }}
						</td>
						
						<td>
							{{ stat.category }}
						</td>
						
						<td>
							{{ stat.subject }}
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	